import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPanelLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.75 13.5V2.5M6.75 2.5H2.13095C1.36827 2.5 0.75 3.09695 0.75 3.83333V12.1667C0.75 12.903 1.36827 13.5 2.13095 13.5H13.869C14.6317 13.5 15.25 12.903 15.25 12.1667V3.83333C15.25 3.09695 14.6317 2.5 13.869 2.5H6.75Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M2.5 5.25H5M2.5 7.25H5M2.5 9.25H5",
		stroke: "currentColor"
	})]
});
export default SvgPanelLeft;
